import React, { useState, useContext, useEffect } from "react";
import { Tabs } from "antd";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import apiUrl from "../../ApiEndpoint/config";
import apiClient from "../../ApiEndpoint/apiClient";
import Spinner from "../Spinner/spinner.js";
const { TabPane } = Tabs;

const BuildingOwnerTabs = () => {
  const { bldOwner } = useContext(RegisterIdContext);
  const [buildingOwnerInfo, setBuildingOwnerInfo] = useState(null);
  const [buildingOwnerOverview, setBuildingOwnerOverview] = useState(null);
  const [buildingSustainability, setBuildingSustainability] = useState(null);
  const [loading, setLoading] = useState(true); // for spinner

  useEffect(() => {
    if (!bldOwner) return;

    const fetchBuildingOwnerInfo = async () => {
      try {
        setLoading(true);

        const [buildingOwnerRes, ownerOverviewRes, sustainabilityRes] = await Promise.all([
          apiClient.get(`${apiUrl}/building_owner_info`, {
            params: { ownerofrecord: bldOwner },
          }),
          apiClient.get(`${apiUrl}/owner_overview`, {
            params: { owner_of_record: bldOwner },
          }),
          apiClient.get(`${apiUrl}/building_sustainability`, {
            params: { owner_of_record: bldOwner },
          })
        ]);

        setBuildingOwnerInfo(buildingOwnerRes.data?.building_owner_info || {});
        setBuildingOwnerOverview(ownerOverviewRes?.data || {});
        setBuildingSustainability(sustainabilityRes?.data || {});
      } catch (error) {
        console.error("Error fetching building owner info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBuildingOwnerInfo();
  }, [bldOwner]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="card" style={{ padding: '10px' }}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Owners Details" key="1">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Overview" key="1">
              <Overview bldOwner={bldOwner} buildingOwnerInfo={buildingOwnerInfo} buildingOwnerOverview={buildingOwnerOverview} />
            </TabPane>
          </Tabs>
        </TabPane>

        <TabPane tab="Sustainability Goals" key="2">
          <SustainabilityGoals buildingSustainability={buildingSustainability} />
        </TabPane>
        {/* <TabPane tab="News" key="3"></TabPane>
      <TabPane tab="Contacts" key="4"></TabPane> */}
      </Tabs>
    </div>
  );
};

const Overview = ({ bldOwner, buildingOwnerInfo, buildingOwnerOverview }) => {
  const data = buildingOwnerInfo ? buildingOwnerInfo[0] : {};
  if (!buildingOwnerOverview) {
    return <Spinner />;
  }
  const Message = buildingOwnerOverview?.Message || "An error occured while fetching the data.Please contact the administrator.";
  const Citations = buildingOwnerOverview?.Citations;
  return (
    <div style={{ maxHeight: '55vh', overflowY: 'scroll' }}>
      <h5
        style={{
          color: "#098192",
          paddingTop: "10px",
          paddingBottom: "10px",
          fontWeight: "800",
        }}
      >
        {bldOwner}
      </h5>
      <p>{Message}</p>
      {Citations && Citations.length > 0 && (
        <ul>
          {Citations.map((citation, index) => {
            // Match Markdown-style [label](url)
            const match = citation.match(/\[([^\]]+)\]\(([^)]+)\)/);
            if (!match) return null;

            const label = match[1];
            const url = match[2];

            return (
              <li key={index}>
                <span>{label}:</span>{" "}
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
              </li>
            );
          })}
        </ul>
      )}
      <h6 style={{ fontWeight: "800" }}>Building Details</h6>
      <div className="details-grid">
        <span className="leftlabel">Total Number Of Building</span>{" "}
        <span>{data?.total_building_count || "N/A"}</span>
        <span className="leftlabel">Distinct Type Of Building</span>{" "}
        <span>{data?.building_type_list?.join(",") || "N/A"}</span>
        <span className="leftlabel">Total GHG Emmissions</span>{" "}
        <span>
          {data?.ghg_emmisions_metric_tons
            ? data?.ghg_emmisions_metric_tons + " Metric ton"
            : "N/A"}
        </span>
        <span className="leftlabel">Total Electricity Usage</span>{" "}
        <span>
          {data?.total_electric_usage
            ? data?.total_electric_usage + " kWh"
            : "N/A"}
        </span>
        <span className="leftlabel">Total Natural Gas Usage</span>{" "}
        <span>
          {data?.total_natural_gas_usage
            ? data?.total_natural_gas_usage + " kBtu"
            : "N/A"}
        </span>
        <span className="leftlabel">Total Other Fuel Usage </span>{" "}
        <span>
          {data?.total_other_fuels_usage
            ? data?.total_other_fuels_usage + " kBtu"
            : "N/A"}
        </span>
        <span className="leftlabel">Total Stream Usage</span>{" "}
        <span>
          {data?.total_steam_usage ? data?.total_steam_usage + " kBtu" : "N/A"}
        </span>
        <span className="leftlabel">Total Hot Water Usage</span>{" "}
        <span>
          {data?.total_hot_water_usage
            ? data?.total_hot_water_usage + " kBtu"
            : "N/A"}
        </span>
      </div>
    </div>
  );
};

const SustainabilityGoals = ({ buildingSustainability }) => {

  const Message = buildingSustainability?.Message || "An error occured while fetching the data.Please contact the administrator.";
  const Citations = buildingSustainability?.Citations;
  return (
    <div>
      <h5 style={{ color: '#098192', paddingTop: '10px', paddingBottom: '10px', fontWeight: '800' }}>
        Sustainability Goals
      </h5>
      <p>{Message}</p>
      {Citations && Citations.length > 0 && (
        <ul>
          {Citations.map((citation, index) => {
            // Match Markdown-style [label](url)
            const match = citation.match(/\[([^\]]+)\]\(([^)]+)\)/);
            if (!match) return null;

            const label = match[1];
            const url = match[2];

            return (
              <li key={index}>
                <span>{label}:</span>{" "}
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default BuildingOwnerTabs;
